import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});


api.interceptors.request.use((config) => {
  const token = localStorage.getItem("employeeToken"); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default api;
